import { useMutation, useQueryClient } from '@tanstack/react-query';
import { logout } from 'api/auth.service';
import { AxiosError } from 'axios';
import { useToast } from 'hooks/ui';
import { useNavigate } from 'react-router-dom';
import { removeCurrentUser } from 'store/user';

export const useAdminLogout = () => {
  const navigate = useNavigate();
  const toast = useToast();
  const queryClient = useQueryClient();

  const { isPending, mutate } = useMutation({
    mutationFn: logout,
    onSuccess: () => {
      queryClient.clear();
      removeCurrentUser();
      navigate('/login');
    },
    onError: (error: AxiosError) => {
      toast.error(error.message);
    },
  });

  return { isLoading: isPending, mutate };
};
